import { EMAIL_CREATION_FORM_FIELD_NAME_TO } from '../../../../Email'

export const APPLICANT_PROFILE_EMAILS_COMPOSE_RESIZE_CONFIG = {
  initialFullScreen: false,
}

export const APPLICANT_PROFILE_EMAILS_COMPOSE_FIELDS_PROPS = {
  [EMAIL_CREATION_FORM_FIELD_NAME_TO]: { blocked: true },
}

export const APPLICANT_PROFILE_EMAILS_COMPOSE_FORM_FIELDS_PROPS = {
  hideCcBcc: true,
}
